<template>
  <div>
    <div
      class="relative flex md:py-11 items-center gap-1 md:gap-6 max-md:flex-col-reverse max-md:rounded-[15px] max-md:bg-[#C4E0FF]"
    >
      <div class="w-full rounded-[15px] bg-[#C4E0FF]">
        <div
          class="lg:w-[45%] md:w-2/5 w-full md:py-16 md:ltr:ml-10 md:rtl:mr-10 max-md:px-4 pb-8 flex flex-col gap-10"
        >
          <div class="flex flex-col gap-5">
            <span
              class="md:text-heading-2 text-mobile-heading-2 text-primary-1"
            >
              {{ title }}
            </span>
            <span
              class="md:text-paragraph-1 text-mobile-paragraph-1 text-primary-1"
            >
              {{ description }}
            </span>
          </div>
          <div class="flex flex-col gap-5" v-if="subCategories.length">
            <span
              class="md:text-heading-5 text-mobile-heading-5 text-primary-1"
            >
              {{ t("discover.bannerSubcategoryTitle") }}
            </span>
            <div
              class="flex flex-wrap md:gap-3 gap-y-2.5 gap-x-[10px] md:gap-x-5"
            >
              <h6
                v-for="subCategory in subCategories"
                :key="subCategory.title"
                class="md:text-heading-6 text-mobile-heading-6 bg-body-bg rounded-full px-4 md:px-5 py-2.5 border-[1px] border-gray-2 cursor-pointer"
                @click="handleSubCategoryClick(subCategory.slug)"
              >
                {{ subCategory?.title }}
              </h6>
            </div>
          </div>
        </div>
      </div>
      <div
        class="md:absolute md:ltr:mr-[68px] md:rtl:ml-[68px] md:ltr:right-0 md:rtl:left-0 md:top-1/2 md:-translate-y-1/2 max-md:w-full max-md:px-5 max-md:relative"
      >
        <NuxtImg loading="lazy"
          :src="imageUrl ?? 'https://picsum.photos/368/550'"
          class="md:w-[368px] md:max-h-[550px] max-md:h-[397px] md:min-h-[430px] w-full max-w-sm md:aspect-[368/550] rounded-[15px] z-10 relative max-md:-top-10 max-md:mx-auto object-cover"
        />
        <NuxtImg loading="lazy"
          :src="imageUrl ?? 'https://picsum.photos/368/550'"
          class="md:w-[292px] md:h-[400px] w-[235px] h-[289px] rounded-[15px] blur-[35px] absolute md:-right-12 md:top-1/2 md:-translate-y-1/2 bottom-8 md:bottom-0 max-md:translate-x-1/2 right-1/2 object-cover"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import type { IFacetsCategory } from "../../types/general";
import type { PropType } from "vue";

const props = defineProps({
  facetsCategories: {
    type: Array as PropType<IFacetsCategory[]>,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  imageUrl: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();
const subCategories = props.facetsCategories
  .flatMap((category) => category.sub_categories)
  .filter(Boolean)
  .slice(0, 6)
  .sort(
    (subCategoryOne, subCategoryTwo) =>
      subCategoryTwo.product_count - subCategoryOne.product_count
  );

const localePath = useLocalePath();
const router = useRouter();
const emit = defineEmits(["scroll-to-activities"]);

const handleSubCategoryClick = (slug: string) => {
  if (slug) {
    router.push(
      localePath({ name: "things-to-do-in-slug", query: { category: slug } })
    );
    emit("scroll-to-activities");
  }
};
</script>
<style lang="scss" scoped>
.dark-mode {
  h6 {
    @apply text-title-color;
  }
}
</style>
